var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "content",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.3333C8.51119 11.3333 7.25008 10.8166 6.21675 9.78329C5.18341 8.74996 4.66675 7.48885 4.66675 5.99996C4.66675 4.51107 5.18341 3.24996 6.21675 2.21663C7.25008 1.18329 8.51119 0.666626 10.0001 0.666626C11.489 0.666626 12.7501 1.18329 13.7834 2.21663C14.8167 3.24996 15.3334 4.51107 15.3334 5.99996C15.3334 7.48885 14.8167 8.74996 13.7834 9.78329C12.7501 10.8166 11.489 11.3333 10.0001 11.3333ZM3.75008 10.8333C2.81675 10.4 2.06953 9.74996 1.50841 8.88329C0.947304 8.01663 0.666748 7.05551 0.666748 5.99996C0.666748 4.9444 0.947304 3.98329 1.50841 3.11663C2.06953 2.24996 2.81675 1.59996 3.75008 1.16663C3.98341 1.05551 4.19453 1.06385 4.38341 1.19163C4.5723 1.3194 4.66675 1.52774 4.66675 1.81663C4.66675 1.92774 4.63064 2.03607 4.55841 2.14163C4.48619 2.24718 4.39453 2.32774 4.28341 2.38329C3.58341 2.70551 3.02786 3.19163 2.61675 3.84163C2.20564 4.49163 2.00008 5.21107 2.00008 5.99996C2.00008 6.78885 2.20564 7.50829 2.61675 8.15829C3.02786 8.80829 3.58341 9.2944 4.28341 9.61663C4.39453 9.67218 4.48619 9.74996 4.55841 9.84996C4.63064 9.94996 4.66675 10.0611 4.66675 10.1833C4.66675 10.4611 4.5723 10.6666 4.38341 10.8C4.19453 10.9333 3.98341 10.9444 3.75008 10.8333Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.f01cb29c7eb79141e4d92037d2d4ba5c.svg";
export { ForwardRef as ReactComponent };